import "./index.less";
import template from "./index.html";

function controller(
	$logger, 
	$userProfile, 
	appState, 
	$stateParams, 
	openIdService, 
	$uibModal,
	$window
) {
	const ctrl = this;
	ctrl.appState = appState;
	ctrl.openModal = openModal;
	ctrl.signOut = signOut;

	ctrl.$onInit = () => {
		const user = $userProfile.getUserProfile();
		$logger.error("route failed", {
			user,
			formId: (appState.forms.selected || {}).Id,
			errorMessage: $stateParams.errorMsg
		});

		if(typeof $stateParams.errorMsg === "string" || $stateParams.errorMsg instanceof String) {
			ctrl.errorMsg = $stateParams.errorMsg;
		}
	};

	ctrl.reload = () => {
		$window.location.reload();
	};

	function openModal() {
		$uibModal.open({
			component: "form-selector-modal",
			size: "md"
		});
	}

	function signOut() {
		openIdService.getUserManager().signoutRedirect();
	}
}

export default angular
	.module("vesl.screens.public.failedRoute", [])
	.component("failedRoute", {
		template,
		controller
	}).name;
